import { render, staticRenderFns } from "./Posts.vue?vue&type=template&id=609fae5d&scoped=true&"
import script from "./Posts.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Posts.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609fae5d",
  null
  
)

export default component.exports